import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import Header from '../Common/Header'
import {
  DECORATION_MERCHANT_INTRO,
  M_STATUS_REJECTED,
  M_STATUS_VERIFYING
} from '@constant'
import { AuthPro } from '@common/Auth'
import { dGet } from '@core/utils'
import Img from '@UI/Img'
import { getProTitle } from '@util'

@observer
export default class extends Component {
  getStatus = () => {
    const { allStatus } = this.props.store
    let status = ''
    const dStatus = dGet(allStatus, 'pending_data.des.status')
    const rStatus = dGet(allStatus, 'pending_data.real_photos.status')

    if (dStatus == M_STATUS_REJECTED || rStatus == M_STATUS_REJECTED) {
      status = 'rejected'
    } else if (dStatus == M_STATUS_VERIFYING || rStatus == M_STATUS_VERIFYING) {
      status = 'verifying'
    }

    return status
  }

  render() {
    const {
      store: { homeData, mode, themeConfig }
    } = this.props

    const { des, real_photos } = homeData
    const status = this.getStatus()

    return (
      <Rowbox
        type={DECORATION_MERCHANT_INTRO}
        store={this.props.store}
        style={{
          height: 'auto',
          flexDirection: 'column',
          minHeight: 126
        }}
        vCenter={false}
        status={status}
      >
        <Header
          title="商家简介"
          style={{ borderBottom: `1px solid ${themeConfig['line']}` }}
        />
        <p style={{ margin: '20px 0' }}>{des}</p>

        <div style={{ display: 'flex', marginBottom: 20 }}>
          {(real_photos || [])
            .slice(0, 3)
            .map((item, index) => (
              <Img
                key={index}
                src={item.img}
                style={{ width: 100, height: 62, marginRight: 10 }}
              />
            ))}
        </div>

        {mode === 'editable' && (
          <AuthPro.NotShow>
            <div
              style={{
                height: '33px',
                backgroundColor: 'rgb(217, 174, 100)',
                color: 'rgb(255, 255, 255)',
                position: 'absolute',
                bottom: '0',
                left: '0',
                width: '100%',
                textAlign: 'center',
                lineHeight: '33px',
                zIndex: '2'
              }}
            >
              部分信息开通{getProTitle()}后方可展示给用户
            </div>
          </AuthPro.NotShow>
        )}
      </Rowbox>
    )
  }
}
